import React from 'react';

const StatsBar = ({ coinsShown, totalCoins, isShared }) => {
  if (!isShared || totalCoins === 0) return null;

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <p className="text-sm text-gray-600">
          Showing {coinsShown} of {totalCoins} coins
        </p>
      </div>
    </div>
  );
};

export default StatsBar;
